import { EHouseMaterial } from '../../types/filters';

interface IHouseMaterial {
  label: string;
  value: EHouseMaterial;
}

export const HOUSE_MATERIALS: IHouseMaterial[] = [
  { label: 'Кирпичный', value: EHouseMaterial.Brick },
  { label: 'Деревянный', value: EHouseMaterial.Wood },
  { label: 'Монолитный', value: EHouseMaterial.Monolith },
  { label: 'Щитовой', value: EHouseMaterial.Boards },
  { label: 'Газобетонный блок', value: EHouseMaterial.AerocreteBlock },
  { label: 'Пенобетонный блок', value: EHouseMaterial.FoamConcreteBlock },
];
